import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, of } from 'rxjs';
import { Vacancy } from '../../../vacancies/models/vacancy.model';
import { VacancyMockService } from '../../../vacancies/services/vacancy-mock.service';
import { VacancyDetailData } from '../../../vacancies/pages/vacancy-detail/vacancy-detail.component';
import { CompanyMockService } from '../../services/company-mock.service';
import { Company } from '../../models/company.model';

@Component({
  selector: 'bwc-company-vacancies',
  templateUrl: './company-vacancies.component.html',
  styleUrls: ['./company-vacancies.component.scss'],
})
export class CompanyVacanciesComponent implements OnInit {
  company: Company | undefined;
  vacancies: Vacancy[] = [];
  visibleCount = 30;
  likedIds: number[] = [];
  detailData: VacancyDetailData | null = null;

  private visibleVacancies$ = new BehaviorSubject<Vacancy[]>([]);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private companyService: CompanyMockService,
    private vacancyService: VacancyMockService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      const id = Number(params['id']);
      this.companyService.getCompanyById(id).subscribe(c => (this.company = c));
    });
    this.vacancyService.getVacancies().subscribe(v => (this.vacancies = v));
    this.likedIds = this.vacancyService.getSavedIds();
  }

  get visibleVacancies(): Vacancy[] {
    return this.vacancies.slice(0, this.visibleCount);
  }

  get hasMore(): boolean {
    return this.visibleCount < this.vacancies.length;
  }

  loadMore(): void {
    this.visibleCount = Math.min(this.visibleCount + 30, this.vacancies.length);
  }

  isLiked(id: number): boolean {
    return this.likedIds.includes(id);
  }

  toggleLike(vacancy: Vacancy): void {
    const saved = this.vacancyService.toggleSaveVacancy(vacancy);
    this.likedIds = saved
      ? [...this.likedIds, vacancy.id]
      : this.likedIds.filter(i => i !== vacancy.id);
  }

  openDetail(vacancy: Vacancy): void {
    const visible = this.vacancies.slice(0, this.visibleCount);
    this.visibleVacancies$.next(visible);
    const index = visible.findIndex((v) => v.id === vacancy.id);
    if (index < 0) return;
    this.detailData = {
      vacancies$: this.visibleVacancies$.asObservable(),
      initialIndex: index,
      hasMore$: of(false),
    };
  }

  closeDetail(): void {
    this.detailData = null;
  }

  goBack(): void {
    if (this.company) {
      this.router.navigate(['/profile-check/companies', this.company.id]);
    }
  }
}
